import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppFloat } from './WhatsAppFloat';

export function WebLayout({ children }) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-bg font-sans text-text">
      <a
        href="#main"
        className="absolute left-4 -top-24 z-[100] rounded-md bg-accent px-4 py-2 font-bold text-black focus:top-4"
      >
        Skip to content
      </a>

      <Navbar />

      <main id="main">{children}</main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
